import React from "react";
import { Link } from "react-router-dom";

import "../../styles/commons/TopBar.css";

import logoCirculumAI from "../../assets/brand/circulumai-logo.png";

export default function TopBar({ isChatbot, onOpenHistory, onOpenSoon }) {
  return (
    <header className="alx-header">
      <Link to="/" className="alx-brand" aria-label="CirculumAI – Accueil">
        <img className="alx-logo-img" src={logoCirculumAI} alt="CirculumAI" />
        <span className="alx-brand-text is-desktop">CirculumAI</span>
        <span className="alx-brand-text is-mobile">CAI</span>
        <span className="demo-header-badge is-desktop">Mode démo</span>
      </Link>

      <nav className="alx-nav" aria-label="Barre d’actions démo">
        <button
          type="button"
          className={"demo-top-action demo-top-action--history is-mobile"}
          aria-label="Historique"
          onClick={onOpenHistory}
          disabled={!isChatbot}
          title={!isChatbot ? "Disponible sur Chatbot IA" : "Ouvrir l'historique"}
        >
          <IconHistory />
        </button>

        <button type="button" className="demo-top-action" aria-label="Guide" onClick={() => onOpenSoon("Guide")}>
          <IconGuide />
          <span className="demo-top-action-text is-desktop">Guide</span>
        </button>

        <button
          type="button"
          className="demo-top-action"
          aria-label="Notifications"
          onClick={() => onOpenSoon("Notifications")}
        >
          <span className="demo-notif-dot" aria-hidden="true" />
          <IconBell />
          <span className="demo-top-action-text is-desktop">Notifs</span>
        </button>

        <button type="button" className="demo-top-action" aria-label="Paramètres" onClick={() => onOpenSoon("Paramètres")}>
          <IconGear />
          <span className="demo-top-action-text is-desktop">Params</span>
        </button>

        <Link className="alx-login is-desktop" to="/login" aria-label="Se connecter">
          Se connecter
        </Link>

        <Link className="alx-login is-mobile" to="/login" aria-label="Connexion">
          Connexion
        </Link>
      </nav>
    </header>
  );
}

function IconHistory() {
  return (
    <svg viewBox="0 0 24 24" className="demo-top-ico" aria-hidden="true">
      <path d="M3 12a9 9 0 1 0 3-6.7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M3 4v5h5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7v6l4 2"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconGuide() {
  return (
    <svg viewBox="0 0 24 24" className="demo-top-ico" aria-hidden="true">
      <path
        d="M6 3h10a2 2 0 0 1 2 2v14a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M8 7h8M8 11h8M8 15h6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function IconBell() {
  return (
    <svg viewBox="0 0 24 24" className="demo-top-ico" aria-hidden="true">
      <path d="M12 22a2 2 0 0 0 2-2H10a2 2 0 0 0 2 2Z" fill="none" stroke="currentColor" strokeWidth="2" />
      <path
        d="M18 16V11a6 6 0 1 0-12 0v5l-2 2h16l-2-2Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconGear() {
  return (
    <svg viewBox="0 0 24 24" className="demo-top-ico" aria-hidden="true">
      <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" fill="none" stroke="currentColor" strokeWidth="2" />
      <path
        d="M19.4 15a7.9 7.9 0 0 0 .1-2l2-1.2-2-3.5-2.3.7a7.3 7.3 0 0 0-1.7-1l-.3-2.4H10l-.3 2.4a7.3 7.3 0 0 0-1.7 1L5.7 8.3l-2 3.5 2 1.2a7.9 7.9 0 0 0 .1 2l-2 1.2 2 3.5 2.3-.7a7.3 7.3 0 0 0 1.7 1l.3 2.4h4.8l.3-2.4a7.3 7.3 0 0 0 1.7-1l2.3.7 2-3.5-2-1.2Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}